<script>
  import Icon from "../../../../shared/javascripts/svelte/Components/Icon.svelte";
  export let isVisible = false;
  export let svelteCloseCallback;

  function closeCallback() {
    svelteCloseCallback();
  }

</script>

{#if isVisible}
  <div class={`search__search-container ${isVisible ? "scale-search" : "descale-search"}`}>
    <div class="search__search-content-wrapper">
      <div class="search__input-container">
        <button on:click={closeCallback} class="button search__close-button">
          <Icon type="X" height="28" width="28" />
        </button>
        <slot />
      </div>
    </div>
  </div>
{/if}
